import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchImageByName } from "../../utils/utility";
import { store } from "../../redux/store";

const useStyles = makeStyles((theme) => ({
  background: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: -2,
    objectFit: "cover",
  },
  dark: {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    zIndex: -1,
    opacity: 0.4,
    backgroundColor: "#000",
  },
}));

const BackgroundComponent = ({ transparent, onClick }) => {
  const [ratio, setRatio] = useState(window.innerHeight / window.innerWidth);
  const classes = useStyles();
  const gender = store.getState().gameStates.case.gender;

  useEffect(() => {
    window.addEventListener("resize", () => {
      setRatio(window.innerHeight / window.innerWidth);
    });
  }, []);

  return (
    <>
      {transparent ? <div className={classes.dark} onClick={onClick} /> : <></>}
      <img
        src={
          ratio >= 1
            ? gender === "male"
              ? fetchImageByName("maleLyingPortrait")
              : fetchImageByName("femaleLyingPortrait")
            : gender === "male"
            ? fetchImageByName("maleLyingFull")
            : fetchImageByName("femaleLyingFull")
        }
        alt="Patient"
        className={classes.background}
      />
    </>
  );
};

export default BackgroundComponent;
